import {groupRiskStatus} from '../../../util/uiconstants';

const getCounts = ({primaryAccounts, primaryRisks}, groupStatusId) => {
	const accountsCounts = primaryAccounts?.filter(x => x.groupRiskStatusId === groupStatusId)?.length ?? 0;
	const risksCounts = primaryRisks?.filter(x => x.groupRiskStatusId === groupStatusId)?.length ?? 0;

	return accountsCounts + risksCounts;
}

export default (data, primaryEngagementId) => {
	return data.map((entity) => {
		const open = getCounts(entity, groupRiskStatus.open) + getCounts(entity, groupRiskStatus.systemReOpened);
		const assessed = getCounts(entity, groupRiskStatus.assessed);
		return {
			component: entity.componentName,
			open: open === 0 ? '-' : open,
			assessed: assessed === 0 ? '-' : assessed,
			total: open + assessed === 0 ? '-' : open + assessed,
			componentId: entity.componentId,
			primaryEngagementId
		};
	});
};